import { FC } from 'react';
import { useQuery } from '@tanstack/react-query';

import { ProfileContext } from './context.ts';
import { TProviderProps } from './types.ts';

import { API } from '@/services/api';

export const ProfileProvider: FC<TProviderProps> = ({ children }) => {
    const { data, isLoading } = useQuery({
        ...API.AUTH.authCheck(),
        staleTime: 1000 * 60 * 5,
        refetchInterval: 1000 * 60 * 5,
    });
    const isAuthorized = Boolean(data?.logged_in);

    return (
        <ProfileContext.Provider
            value={{
                role: data?.role || undefined,
                isAuthorized,
                loading: isLoading,
            }}
        >
            {children}
        </ProfileContext.Provider>
    );
};
